import type { FC } from 'react';
import { sourceOf } from './sendReport';

// Chip's blue and gray schemes, drawn on a span: Chip's root is a div, and this badge sits inside
// buttons and running text, which may only hold phrasing content.
const colourClasses = {
  check: 'blue b--lightest-blue bg-lightest-blue',
  ai: 'near-black b--moon-gray bg-moon-gray',
} as const;

interface SendFindingSourceProps {
  finding: { origin?: string | null };
  className?: string;
}

/**
 * Badge naming where a SEND finding came from, "Validation check" or "Benchling In Vivo AI", as
 * {@link sourceOf} decides.
 */
const SendFindingSource: FC<SendFindingSourceProps> = ({ finding, className = '' }) => {
  const source = sourceOf(finding);
  return (
    <span
      className={`f6 lh-title dib br2 ba pa2 ${colourClasses[source.key]} ${className}`}
      data-test-element="finding-source"
      data-test-key={source.key}
    >
      {source.label}
    </span>
  );
};

export default SendFindingSource;
